/** Internal URL token — not a real WebSocket endpoint. */
export const MOCK_REALTIME_URL = "mock://realtime" as const;

export const MOCK_TENANT_ID = "11111111-1111-1111-1111-111111111111";
export const MOCK_USER_ID = "22222222-2222-2222-2222-222222222222";

/** Simulated API failure rate (0–1). */
export const MOCK_API_FAILURE_RATE = 0.1;

export const MOCK_DELAY_MS_MIN = 300;
export const MOCK_DELAY_MS_MAX = 800;
